import React, { useEffect, useState } from "react";
import { collection, query, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { Link } from "react-router-dom";


const AllStudentResult = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    const q = query(collection(db, "resultStudent"));
    onSnapshot(q, (querySnapshot) => {
      let studentResultArray = [];
      querySnapshot.forEach((doc) => {
        studentResultArray.push({ id: doc.id, ...doc.data() });
      });
      setList(studentResultArray);
    });
  }, []);

  const deleteResultField = async (rid) => {
    await deleteDoc(doc(db, "resultStudent", rid));
    console.log("Deleted ===>" + rid);
  };

  return (
    <div className="p-5  min-h-screen">
         <div className="w-full p-5 text-gray-700">
        <table className="w-full  text-center">
          <thead className="border-b  ">
            <tr className="bg-gray-100">
              <th className="py-3 ">Sl No.</th>
              <th className="py-3 ">Class</th>
              <th className="py-3 ">Roll No. </th>
              <th className="py-3 ">Id</th>
              <th className="py-3 ">Name</th>
              <th className="py-3 ">Academic session</th>
              <th className="py-3 ">View</th>
              <th className="py-3 ">Update</th>
              <th className="py-3 ">Delete</th>
            </tr>
          </thead>
          <tbody>
            {list?.map((item, index) => (
              <tr className="border-b" key={index}>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {++index}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studied}/{item.classSection}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.classRollNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentIdNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentName}
                </td>
                <td className="py-3 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.academicSession}
                </td>
                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../downloadResult"} state={{ resultId: item.id }}>
                    <div className="text-white bg-yellow-600 py-1 px-1 rounded-md">
                      View
                    </div>
                  </Link>
                </td>
                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../updateResult"} state={{ resultId: item.id }}>
                    <div className="text-white bg-green-600 py-1 px-1 rounded-md">
                      Update
                    </div>
                  </Link>
                </td>

                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-red-600 py-1 px-1 rounded-md "
                    onClick={() => deleteResultField(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AllStudentResult